let coreValuesArray = [];
let currentCoreValue = 0;

function initializeCoreValues() {
    currentCoreValue = Math.floor(Math.random()*coreValuesArray.length);
    $(".coreValueText").html(coreValuesArray[currentCoreValue]);
};

function setCoreValue(shift) {
    if(currentCoreValue + shift < 0) {
        currentCoreValue = coreValuesArray.length - 1;
    }
    else if(currentCoreValue + shift >= coreValuesArray.length) {
        currentCoreValue = 0;
    }
    else {
        currentCoreValue += shift;
    };

    $(".coreValueText").fadeIn(400, () => {
        $(".coreValueText").fadeOut(400, () => {
            $(".coreValueText").fadeIn(400);
            $(".coreValueText").html(coreValuesArray[currentCoreValue]);
        });
    });
};